/**
 * PORTED — RO-11-04 / #44589.
 * Origin: `excellent/app/_chrome/bottom-nav.tsx` (async server component that
 * read capability-surface nav from the shell chrome aggregator).
 *
 * The Next tree still owns the server path. Here we cannot import
 * server-only chrome aggregators into the SPA, so the same selection rule is
 * applied against a static shortcut registry that mirrors the CRM (and peers)
 * nav items flagged `shortcut` — first 5, deduped by href. Icons via `Icon`
 * so we never ship Lucide components across a server boundary.
 */

import { Icon } from "@excellent/ui";
import { BottomNavClient, type BottomNavItem } from "./bottom-nav-client";

/** Shortcut'd mobile destinations — same order/shape the server chrome aggregator yields. */
const SHORTCUT_NAV: Array<{ href: string; label: string; icon: string }> = [
  { href: "/", label: "Overview", icon: "gauge" },
  { href: "/queue", label: "Queue", icon: "inbox" },
  { href: "/findings", label: "Findings", icon: "flag" },
  { href: "/evidence", label: "Evidence", icon: "file" },
  { href: "/settings", label: "Settings", icon: "cpu" },
];

/**
 * Mobile bottom bar — first 5 distinct shortcut destinations.
 * md:hidden in BottomNavClient; no-op on desktop.
 */
export function BottomNav() {
  const seen = new Set<string>();
  const items: BottomNavItem[] = [];
  for (const i of SHORTCUT_NAV) {
    if (seen.has(i.href)) continue;
    seen.add(i.href);
    items.push({
      href: i.href,
      label: i.label,
      icon: <Icon name={i.icon} strokeWidth={1.5} className="w-4 h-4" />,
    });
    if (items.length >= 5) break;
  }
  return <BottomNavClient items={items} />;
}
